import DoctorListComponent from '../components/doctors/DoctorListComponent';

function DoctorList() {
  return <DoctorListComponent />;
}

export default DoctorList;
